import { render, staticRenderFns } from "./blankLayout.vue?vue&type=template&id=b626c71a&scoped=true"
import script from "./blankLayout.vue?vue&type=script&lang=js"
export * from "./blankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b626c71a",
  null
  
)

export default component.exports